import OhsRecordFieldType from 'global-services/constants/record-field/OhsRecordFieldType';

export const OhsContractorBusinessNameRecordField = new OhsRecordFieldType(
  'businessName',
  'Business Name'
);
export const OhsContractorBusinessNotesRecordField = new OhsRecordFieldType(
  'businessNotes',
  'Service Provided/Notes'
);

export const OhsContractorContactsRecordField = new OhsRecordFieldType('contacts', 'Contacts');
export const OhsContractorLogoRecordField = new OhsRecordFieldType('logo', 'Logo');
export const OhsContractorContactNameRecordField = new OhsRecordFieldType('name', 'Name');
export const OhsContractorContactPhonesRecordField = new OhsRecordFieldType(
  'phones',
  'Telephone(s)'
);
export const OhsContractorContactEmailsRecordField = new OhsRecordFieldType('emails', 'Email(s)');
export const OhsContractorApprovalStatusRecordField = new OhsRecordFieldType('status', 'Status');
export const OhsContractorAddressRecordField = new OhsRecordFieldType('address', 'Address');
export const OhsContractorBusinessNumberTypeRecordField = new OhsRecordFieldType(
  'referenceIdType',
  'Business Number Type'
);
export const OhsContractorBusinessNumberRecordField = new OhsRecordFieldType(
  'referenceId',
  'Business Number'
);
export const OhsContractorLocationField = new OhsRecordFieldType('locations', 'Location(s)');

export const OhsAllocationStatus = new OhsRecordFieldType('allocationStatus', 'Allocation');

export const OhsCategoryRecordField = new OhsRecordFieldType('category', 'Category');

export const OhsCategoryOtherRecordField = new OhsRecordFieldType(
  'categoryOther',
  'Category Other'
);

export const OhsSubcategoryRecordField = new OhsRecordFieldType('subcategory', 'Subcategory');

export const OhsSubcategoryOtherRecordField = new OhsRecordFieldType(
  'subcategoryOther',
  'Subcategory Other'
);
